import React, { FunctionComponent } from 'react';
import { Box, CircularProgress } from '@mui/material';

interface LoadingProps {
  minHeight?: string;
  context?: string;
}

export const Loading: FunctionComponent<LoadingProps> = (props) => {
  return (
    <Box
      display="flex"
      justifyContent="center"
      alignItems="center"
      alignContent="center"
      style={{
        minHeight: props.minHeight ?? null,
      }}
    >
      {props.context && <span>{props.context}</span>}
      <CircularProgress />
    </Box>
  );
};

export default Loading;
